import { AlertColor } from '@mui/material';
import { Alert, AutoThemeProvider, Spinner, Table } from '@platform-ui/design-system';
import { RowActionType } from '@platform-ui/design-system/dist/types/Table';
import $ from 'jquery';
import React, { useEffect, useState } from 'react';
import Connect from "../Connect/Connect";

function TasksTable(props: any) {

    const origin = Connect.path();  // Determine the path prefix for redirection

    // Table Consts
    const [rows, setRows] = useState<any[]>([]);
    const [tableActions, setTableActions] = useState([])
    const [rowActions, setRowActions] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [loading, setLoading] = useState(true);
    const [noRows, setNoRows] = useState(false);

    // Alert Consts
    const [isAlert, setIsAlert] = useState(false);
    const [alertSeverity, setAlertSeverity] = useState("success");
    const [alertHeader, setAlertHeader] = useState("");
    const [alertBody, setAlertBody] = useState("");

    // NOTE(Xander): In order to ensure the table is reloaded after certain actions, this value can be toggled
    // The reload will happen every time the value is changed, not simply when it is true
    const [reloadTable, setReloadTable] = useState(false);

    // NOTE(Xander): In order to use older Connect modals with the new table, we need to replicate Rails-Ajax functionality
    // This method ensures that all links generated by the table will render their modal on the same page without redirecting
    const ajaxCall = () => {
        $(".MuiList-root a").attr("data-remote", true);
    }

    // NOTE(Michael): this is use to detech when the user is finished typing in the search bar
    const [searchValue, setSearchValue] = useState('')
    useEffect(() => {
        const timer = setTimeout(() => {
            fetchFromBackend(searchValue)
        }, 500)
        if (searchValue.length === 0 && rows.length > 0) {
            setNoRows(false);
        }
        return () => clearTimeout(timer)
    }, [searchValue])

    useEffect(() => {
        getTasks(null);
    }, [reloadTable]);

    const getTasks = async (event: any) => {
        setLoading(true);
        const URL = props.backend_uri;
        try {
            const options = {
                headers: new Headers({
                    'Accept': 'application/json',
                    'Content-type': 'application/json'
                })
            };
            const response = await window.fetch(props.backend_uri, options);
            if (!response.ok) throw Error(response.statusText);
            const data = await response.json();
            setRows(data.rows);
            setTableActions(generateTableActions(data.tableActions));
            setRowActions(
                [
                    {
                        icon: 'more_horiz',
                        onClick: getRowActions,
                        listChildren: []
                    }
                ]
            );
            if (data.rows.length === 0) {
                setNoRows(true);
            } else {
                setNoRows(false);
            }
            setLoading(false);
        } catch (error) {
            console.error(error);
            setRows([]);
            setRowActions([]);
            setLoading(false);
            setNoRows(true);
        }
    }

    const apiCall = element => {
        try {
            // NOTE(Xander): This query grabs the rails CSRF token for requests
            let csrf = document.querySelector("meta[name='csrf-token']").getAttribute("content");
            fetch(element.path, {
                method: element.method,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrf
                }
            }).then((response) => {
                setReloadTable(!reloadTable);
                if (response.status == 200 || response.ok == true) {
                    setAlertHeader("Successfully Performed Action");
                    // setAlertBody("Aren't you a cool guy!");
                    setAlertSeverity("success");
                } else {
                    setAlertHeader(`${response.status}: ${response.statusText}`);
                    setAlertBody("Please Try Again Later");
                    setAlertSeverity("error");
                }
                setIsAlert(true);
            }).catch((error) => {
                console.error(error);
            });
        } catch (error) {
            console.error(error);
        }
    }

    const fetchFromBackend = async (args) => {
        if (args.length != 0) {
            setFetching(true);
            if (props.backend_uri.includes("?")) {
                var url = props.backend_uri + "&";
            } else {
                var url = props.backend_uri + "?";
            }

            try {
                const options = {
                    headers: new Headers({
                        'Accept': 'application/json',
                        'Content-type': 'application/json'
                    })
                };
                const response = await window.fetch(url + new URLSearchParams({ sSearch: args, iDisplayLength: '10' }), options);
                if (!response.ok) throw Error(response.statusText);
                const data = await response.json();
                var ids = new Set(rows.map(d => d.id));
                var merged = [...rows, ...data.rows.filter(d => !ids.has(d.id))];
                if (data.rows.length === 0) {
                    setNoRows(true);
                }
                setRows(merged);
                setFetching(false);
            } catch (error) {
                console.error(error)
                setFetching(false);
            }
        }
    }

    function generateTableActions(allowed_applications) {
        const tableActions = [
            {
                icon: "add_circle_outline",
                listChildren: []
            },
            {
                icon: "sync",
                label: "Refresh Tenants",
                onClick: getTasks,
            }
        ]
        allowed_applications.forEach(element => {
            tableActions[0].listChildren.push(
                {
                    label: element.label,
                    href: element.path,
                    onClick: ajaxCall
                }
            )
        });
        return tableActions
    }

    const getRowActions = async (event) => {
        try {
            let csrf = document.querySelector("meta[name='csrf-token']").getAttribute("content");
            const options = {
                headers: new Headers({
                    'Accept': 'application/json',
                    'Content-type': 'application/json',
                    'X-CSRF-Token': csrf
                })
            };
            // NOTE(Xander): When processing requests from billing, we must prepend /services/connect
            let path = (window.location.pathname.includes('admin') ? '/admin' : '') + '/tools/tasks/actions/' + event.row.id;
            if (!window.location.host.includes('connect') && !window.location.host.includes('localhost')) {
                path = '/services/connect' + path;
            }
            const response = await window.fetch(path, options);
            if (!response.ok) throw Error(response.statusText);
            const actions = await response.json();
            setRowActions(regenerateRowActions(actions));
        } catch (error) {
            console.error(error)
        }
    }

    function regenerateRowActions(actions) {
        return [
            {
                dsGetActionData: (row) => {
                    let listChildren: RowActionType[] = [];
                    row.actions = actions
                    if (row.actions != null) {
                        let template_link: RowActionType = {};
                        row.actions.forEach((element) => {
                            template_link = {
                                label: element.label
                            };
                            if (element.ajaxCall) {
                                template_link.onClick = ajaxCall
                            }
                            if (element.method === "get") {
                                template_link.href = element.path
                            } else {
                                template_link.onClick = () => {
                                    apiCall(element);
                                }
                            }
                            if (element.disabled) {
                                template_link.disabled = true
                            }
                            listChildren.push(template_link);
                        });
                        return {
                            icon: 'more_horiz',
                            listChildren: listChildren,
                            onClick: getRowActions
                        };
                    }
                }
            }
        ];
    }



    return (
        <AutoThemeProvider>
            <Alert
                body={alertBody}
                dismissible
                dsOnClose={() => {
                    setIsAlert(false);
                }}
                e2e="taskAlert"
                header={alertHeader}
                open={isAlert}
                severity={alertSeverity as AlertColor}
            />
            <Table
                columns={[
                    {
                        field: 'id',
                        label: 'ID',
                        labelTooltip: 'A unique identifier'
                    },
                    {
                        field: 'name',
                        label: 'Name'
                    },
                    {
                        field: 'created_by',
                        label: 'Created By',
                        dsRenderCell: ({ value }) => {
                            return <a href={origin + "/users/" + value + "/profile"}>{value}</a>;
                        }
                    },
                    {
                        field: 'start_time',
                        label: 'Start Time'
                    },
                    {
                        field: 'created_at',
                        label: 'Created At'
                    },
                    {
                        field: 'duration',
                        label: 'Duration'
                    },
                    {
                        field: 'results',
                        label: 'Results'
                    },
                    {
                        field: 'status',
                        label: 'Status'
                    },
                    {
                        field: 'mode',
                        label: 'Mode'
                    },
                    {
                        field: 'execution',
                        label: 'Execution'
                    },
                    {
                        field: 'application',
                        label: 'Application'
                    },
                    {
                        field: 'build',
                        label: 'Build'
                    }
                ]}
                loading={loading}
                uniqueKey={'id'}
                nestedDataKey={'parent_id'}
                tableActions={tableActions}
                showGroupedRowsControls={true}
                e2e="tasksTable"
                rows={rows}
                rowActions={rowActions}
                rowsPerPage={20}
                orderable
                dsOnSearchChange={(args) => setSearchValue(args)}
                rowDisplayOptions={{ highlight: false }}
            />
            <p style={fetching ? {} : { display: 'none' }}>
                <Spinner variant="linear" />
                <p>
                    Fetching from the database
                </p>
            </p>
        </AutoThemeProvider>
    );
}
export default TasksTable;
